export function buildFarmerHarvestProofHref(token: string): string {
  return `/farmer-harvest-proof?token=${encodeURIComponent(token)}`;
}
